export enum MatchingProgress {
  LOADING = 'MatchingProgress.loading',
  SUCCESS = 'MatchingProgress.success',
  FAILED = 'MatchingProgress.failed',
}
export interface MatchingState {
  matchingData: GD_tournaments.MatchingData
}
